import EmptyInbox from './EmptyInbox'

export default EmptyInbox
